import type * as DialogPrimitive from '@radix-ui/react-dialog'

export { default, type ModalContentProps } from './Modal'

export type ModalProps = DialogPrimitive.DialogProps
